import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";

export const CityCard = ({ city, index }) => {
  return (
    <Link 
      to={`/ciudad/${city.id}`}
      data-testid={`city-card-${city.id}`}
    >
      <Card className="group overflow-hidden rounded-2xl border-0 card-hover bg-white">
        {/* Image */}
        <div className="aspect-[4/3] overflow-hidden relative">
          <img
            src={city.image}
            alt={`Intercambio de idiomas en ${city.name}`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            loading={index < 8 ? "eager" : "lazy"}
          />
          {/* Overlay gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          
          {/* Flag badge */}
          <div className="absolute top-3 right-3 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center text-xl shadow-lg">
            {city.flag}
          </div>

          {/* Hover CTA */}
          <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0">
            <span className="text-white font-medium text-sm">
              Ver intercambios
            </span>
            <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
              <ArrowRight className="w-4 h-4 text-primary" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 className="font-heading font-bold text-lg text-foreground mb-1 group-hover:text-primary transition-colors">
            {city.name}
          </h3>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            <MapPin className="w-3.5 h-3.5" />
            {city.country}
          </p>
        </div>
      </Card>
    </Link>
  );
};
